export default {
  maritalStatuses: {
    SINGLE: 'Célibataire',
    DIVORCED: 'Divorcé(e)',
    MARRIED: 'Marié(e)',
    SEPARATED: 'Séparé(e)',
    FREE_UNION: 'En union libre',
    WIDOW: 'Veuf/veuve',
    PACS: 'Pacsé(e)',
  },
  yourSituationTitle: 'Votre situation',
  yourSituationTitleMinor: 'Votre enfant',
  yourSituationTitleProEI: 'Information sur votre activité',
  yourSituationTitleProPM: 'Situation de l\'entreprise',
  youSubtitle: 'Vous',
  youSubtitlePro: 'Informations générales',
  profileMajor: `{fullNameBold}{br}Date de naissance: {dateOfBirthBold} ({ageBold} ans ){br}Nationalité(s): {nationalitiesBold}{br}Profession(s) : {professionsBold}`,
  profileMajorWithMaritalStatus: `{fullNameBold}{br}Date de naissance: {dateOfBirthBold} ({ageBold} ans ){br}Nationalité(s): {nationalitiesBold}{br}Profession(s) : {professionsBold}{br}Statut marital : {maritalStatusBold} en {maritalRegimeBold}`,
  profileMajorWithMaritalStatusMarried: `{fullNameBold}{br}Date de naissance: {dateOfBirthBold} ({ageBold} ans ){br}Nationalité(s): {nationalitiesBold}{br}Profession(s) : {professionsBold}{br}Statut marital : {maritalStatusBold} en {maritalRegimeBold} à compter du {maritalRegimeStartDateBold}`,
  profileMinor: `{fullNameBold}{br}Date de naissance: {dateOfBirthBold} ({ageBold} ans ){br}Nationalité(s): {nationalitiesBold}`,
  profileProEI: `Nom de l'entreprise : {fullNameBold}{br}Adresse de l'entreprise : {taxAddressBold}{br}Activité principale : {nafLabelBold}({nafCodeBold})`,
  profileProPM: `Raison sociale : {fullNameBold}{br}Adresse du siège social : {taxAddressBold}{br}Activité principale : {nafLabelBold}({nafCodeBold})`,
  clientRetirementAgeChange: `Vous nous avez déclaré que votre âge prévisible de départ à la retraite n'est plus {clientRetirementAgeInitial} ans mais {clientRetirementAgeUpdated} ans.`,
  yourRelatives: 'Vos proches',
  yourPartnerMARRIED: `Votre conjoint : {partnerFullNameBold}`,
  yourPartnerPACS: `Votre partenaire : {partnerFullNameBold}`,
  yourPartnerFREE_UNION: `Votre concubin(e) : {partnerFullNameBold}`,
  yourPartner: 'Votre {partnerRelationshipBold} : {partnerFullNameBold}',
  yourChildren: `Vous avez {childrenTotalBold} enfants :`,
  yourChildDetails: `{childrenFullNameBold}, {childAge} ans`,

  legalRepresentation: 'Représentation légale',
  legalRepresentativeFullYes: `{fullNameBold}{br}Date de naissance: {dateOfBirth} ({age} ans ){br}Nationalité(s): {nationalities}{br}Présence lors de l'entretien: Oui`,
  legalRepresentativeFullNo: `{fullNameBold}{br}Date de naissance: {dateOfBirth} ({age} ans ){br}Nationalité(s): {nationalities}{br}Présence lors de l'entretien: Non`,
  legalRepresentativeProPM: `{fullNameBold}{br}Fonction : {function}`,

  legalInformationTitle: 'Informations juridiques',
  legalInformationText: `Forme Juridique : {legalStatusBold}{br}SIREN/SICLEN : {sirenSiclenBold}`,

  presentForCouncilTitle: 'Présent pour ce conseil',
  presentForCouncilText: `{fullNameBold}{br}Date de naissance: {dateOfBirthBold} ({ageBold} ans ){br}Nationalité(s): {nationalitiesBold}`,

  actingCapacityTitle: 'Qualité pour agir',
  actingCapacityMandatary: `Vous agissez en qualité de mandataire de la société{br}Pouvoirs confiés : {powersBold}`,
  actingCapacityRepresentative: `Vous agissez en qualité de {functionBold}.{br}Pouvoirs confiés : {powersBold}`,
  actingCapacityOwnName: `Vous agissez en votre nom propre.`,
}
